import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import IconTier from '@/features/tickets/assets/IconTier.vue'
import { ITicketPurchased } from '@/features/tickets/types'
import { computed } from 'vue'
import { useQRCode } from '@vueuse/integrations/useQRCode'
import { useImage } from '@/shared/composables/image'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { mdiCheck, mdiDotsHorizontal } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectedTicket',
  props: {
    ticket: null
  },
  emits: ["show-assignment-interface", "show-tier-change-interface", "show-refund-interface", "show-receipt-interface"],
  setup(__props: any) {

const props = __props as {
  ticket: ITicketPurchased
};

// @ts-expect-error Not a ts file




const getUserDB = computed(() => store.getters.getUserDB)
const { getImageById } = useImage()

const qrCodeText = computed(() => {
  return props.ticket.qrCodeHash
})
const qrCode = useQRCode(qrCodeText, {
  margin: 0,
  color: {
    dark: '#000000FF',
    light: '#FFFFFF00',
  },
})

return { __sfc: true,props, getUserDB, getImageById, qrCodeText, qrCode, IconTier, AvatarPlaceholder, mdiCheck, mdiDotsHorizontal }
}

})